var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{class:{
    'has-label': _vm.hasLabel,
    'is-grid': _vm.isGrid
  },style:([_vm.isGrid ? _vm.gridStyles : {}]),on:{"submit":function($event){return _vm.$emit('submit', $event)}}},[(_vm.hasLabel)?_c('span',{staticClass:"form-label"},[_vm._v(" "+_vm._s(_vm.labelText)+" ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }